import React from "react";
import { Button, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiContentCopy, mdiDotsHorizontal } from "@mdi/js";
import formatDate from "app/containers/Templates/utils/formatDate";
import ContractBadges from "./ContractBadges";
import { getSetDefaultState } from "./templateHelpers";

// Actions column mirrors the Smart Templates list (View / Duplicate / three-dot
// menu) so the two settings pages stay visually aligned.
const ContractRow = ({
  template,
  onOpen,
  onSetDefault,
  onDelete,
  onDuplicate,
}) => {
  const { disabled: setDefaultDisabled, title: setDefaultTitle } =
    getSetDefaultState(template);
  const deleteDisabled = template.is_system;

  const stop = (e) => e.stopPropagation();

  return (
    <tr className="contract-row" onClick={onOpen}>
      <td className="contract-name-cell">
        <div className="contract-name">{template.name}</div>
        <ContractBadges template={template} />
      </td>
      <td className="contract-date-cell">
        {template.is_system ? "-" : formatDate(template.updated_at)}
      </td>
      <td className="contract-actions-cell" onClick={stop}>
        <div className="action-buttons">
          <Button
            variant="outline-primary"
            size="sm"
            className="view-btn"
            onClick={onOpen}
          >
            View
          </Button>

          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-dup-${template.id}`}>Duplicate</Tooltip>
            }
          >
            <Button
              variant="link"
              className="copy-btn"
              onClick={onDuplicate}
              aria-label="Duplicate template"
            >
              <Icon path={mdiContentCopy} size={0.7} />
            </Button>
          </OverlayTrigger>

          <Dropdown>
            <Dropdown.Toggle
              variant="link"
              id={`dropdown-${template.id}`}
              className="three-dots-btn"
            >
              <Icon
                path={mdiDotsHorizontal}
                size={0.67}
                className="text-primary"
              />
            </Dropdown.Toggle>
            <Dropdown.Menu className="contract-dropdown-menu">
              <Dropdown.Item
                disabled={setDefaultDisabled}
                onClick={onSetDefault}
                title={setDefaultTitle}
              >
                Set as Default
              </Dropdown.Item>
              <Dropdown.Item
                disabled={deleteDisabled}
                onClick={onDelete}
                className="text-danger"
              >
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </td>
    </tr>
  );
};

export default ContractRow;
